import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, Flexbox } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import {
  getDefaultPackageSize,
  getNumberFromString,
  getProductDetailWishListInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { CheckBox } from '../General/Checkbox';
import { StockInfo } from '../Product/StockInfo';
import { CountSetter } from '../ProductDetail/CountSetter';
import { ButtonPrimary } from '../General/Button';
import { prop, round } from '../../../utilities';

export interface Props {
  product: any;
  addToCart: (product: any, count) => void;
  selected: boolean;
  onCheckboxChange: (
    goodId: string,
    quantity: number,
    checked: boolean,
  ) => void;
  count: number;
  setCount: (count: number) => void;
  handleRemoveClick: (productId: number, goodId: number) => void;
}

function WishlistProductRow({
  product,
  addToCart,
  selected,
  onCheckboxChange,
  count,
  setCount,
  handleRemoveClick,
}: Props) {
  const info = getProductDetailWishListInfo(product);
  const { name, currency, unit, image, saleByPackage, url, priceInfo } = info;

  const currentGood = prop(product, 'goods.0');
  const price = round(currentGood.final_price, 2).toString();

  const onStock = currentGood.on_stock_count;
  const pckg = currentGood.package;
  const inPackage = getNumberFromString(pckg);
  const step = inPackage > 0 ? inPackage : 1;
  const correctStep = saleByPackage ? step : 1;
  const initialCount = getDefaultPackageSize(pckg);
  const correctinitialCount = saleByPackage ? initialCount : 1;
  const priceCounted = round(Number(price) * (count > 0 ? count : 1), 2);

  React.useEffect(() => {
    setCount(correctinitialCount);
  }, [correctinitialCount]);

  const [innerSelected, setInnerSelected] = React.useState(false);

  React.useEffect(() => {
    setInnerSelected(selected);
  }, [selected]);

  const handleCheckboxChange = event => {
    setInnerSelected(!innerSelected);
    onCheckboxChange(product.good_id, count, !innerSelected);
  };

  const handleAddToCart = e => {
    addToCart(product.good_id, count);
  };

  const removeOnClick = e => {
    handleRemoveClick(product.product_id, product.good_id);
  };

  return (
    <StyledTableRow>
      <MobileWrapper>
        <SelectWrapper>
          {' '}
          <CheckBox
            wrapperStyle={{ marginBottom: 0, marginRight: 0 }}
            type={'checkbox'}
            onClick={handleCheckboxChange}
            name="select"
            selected={selected}
          />
        </SelectWrapper>{' '}
        <MobileItemsWrapper>
          <ImageNameWrapper>
            <ImageWrapper>
              {' '}
              <Image alt={`Obrázok ku produktu ${name}`} src={image} />
            </ImageWrapper>
            <NameWrapper>
              <ProductName to={url}> {name} </ProductName>
              <AttribInfo>{priceInfo}</AttribInfo>
            </NameWrapper>
          </ImageNameWrapper>
          <StockPriceWrapper>
            {' '}
            <OnStockWrapper>
              {' '}
              <StockInfo
                availability={prop(
                  currentGood,
                  'availability.translations.0.avail_name',
                )}
                onStock={onStock}
                unit={unit}
                productInfo={true}
                orderAvailable={prop(
                  currentGood,
                  'availability.order_available',
                )}
              />
            </OnStockWrapper>
            <PriceWrapper>
              {priceCounted} {currency}
            </PriceWrapper>
          </StockPriceWrapper>
          <CountAddToCartWrapper>
            <AmountWrapper>
              <CountSetter
                step={correctStep}
                unit={unit}
                count={count}
                onChange={setCount}
                onStock={onStock}
              />
            </AmountWrapper>
            <AddToCartWrapper>
              <CartButton onClick={handleAddToCart} disabled={false}>
                <SvgIcon
                  width={24}
                  height={24}
                  icon={IconType.newCart}
                  fill={'#FFFFFF'}
                  alt={__('Košík')}
                  title={__('Košík')}
                />
              </CartButton>{' '}
            </AddToCartWrapper>
            <RemoveWrapper>
              <SvgIcon
                onClick={removeOnClick}
                width={12}
                height={12}
                icon={IconType.x}
                marginLeft={24}
                marginRight={0}
                viewBox="0 0 12 12"
                alt="Odstrániť produkt"
                title="Odstrániť produkt"
                fill={'black'}
                cursor={'pointer'}
              />{' '}
            </RemoveWrapper>{' '}
          </CountAddToCartWrapper>
        </MobileItemsWrapper>
      </MobileWrapper>
      <DesktopWrapper>
        <LeftWrapper>
          <SelectWrapper>
            {' '}
            <CheckBox
              wrapperStyle={{ marginBottom: 0, marginRight: 16 }}
              type={'checkbox'}
              onClick={handleCheckboxChange}
              name="select"
              selected={selected}
            />
          </SelectWrapper>{' '}
          <ImageWrapper>
            {' '}
            <Image alt={`Obrázok ku produktu ${name}`} src={image} />
          </ImageWrapper>
          <NameWrapper>
            <ProductName to={url}> {name} </ProductName>
            <AttribInfo>{priceInfo}</AttribInfo>
          </NameWrapper>
        </LeftWrapper>
        <RightWrapper>
          <OnStockWrapper>
            {' '}
            <StockInfo
              availability={prop(
                currentGood,
                'availability.translations.0.avail_name',
              )}
              onStock={onStock}
              unit={unit}
              productInfo={true}
              orderAvailable={prop(currentGood, 'availability.order_available')}
            />
          </OnStockWrapper>
          <PriceWrapper>
            {priceCounted} {currency}
          </PriceWrapper>
          <AmountWrapper>
            <CountSetter
              step={correctStep}
              unit={unit}
              count={count}
              onChange={setCount}
              onStock={onStock}
            />
          </AmountWrapper>
          <AddToCartWrapper>
            <CartButton onClick={handleAddToCart} disabled={false}>
              <SvgIcon
                width={24}
                height={24}
                icon={IconType.newCart}
                fill={'#FFFFFF'}
                alt={__('Košík')}
                title={__('Košík')}
                cursor={'pointer'}
              />
            </CartButton>{' '}
          </AddToCartWrapper>
          <RemoveWrapper>
            <SvgIcon
              onClick={removeOnClick}
              width={12}
              height={12}
              icon={IconType.x}
              marginLeft={24}
              marginRight={0}
              viewBox="0 0 12 12"
              alt="Odstrániť produkt"
              title="Odstrániť produkt"
              fill={'black'}
              cursor={'pointer'}
            />{' '}
          </RemoveWrapper>{' '}
        </RightWrapper>
      </DesktopWrapper>
    </StyledTableRow>
  );
}

const StyledTableRow = styled(Flexbox)`
  border-bottom: 1px solid #e8e8e8;
  height: ${rem(80)};
  width: 100%;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};

  ${({ theme }) => theme.mediab.l1150`
    height:auto;
    min-height: ${rem(80)};
    flex-flow: row wrap;
    flex-direction: column;
`}
`;

const LeftWrapper = styled(Flexbox)`
  align-items: center;
`;

const MobileWrapper = styled(Flexbox)`
  display: none;
  align-items: center;
  ${({ theme }) => theme.mediab.m760`
    display: flex;
    height: 100%;
    flex-direction: row;
  `}
`;
const DesktopWrapper = styled(Flexbox)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.mediab.m760`
    display: none;`}
`;
const RightWrapper = styled(Flexbox)`
  align-items: center;
`;

const MobileItemsWrapper = styled(Flexbox)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const ImageNameWrapper = styled(Flexbox)`
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: ${rem(14)} 0 ${rem(8)} 0;
`;
const StockPriceWrapper = styled(FlexCol)`
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: ${rem(4)} 0;
  align-items: center;
  ${({ theme }) => theme.mediab.s450`
    padding: 0;
`}
`;
const CountAddToCartWrapper = styled(FlexCol)`
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-top: ${rem(8)};
  padding-bottom: ${rem(8)};
`;

const SelectWrapper = styled(FlexCol)``;
const ImageWrapper = styled(FlexCol)`
  width: ${rem(48)};
  min-width: ${rem(48)};
  margin-right: ${rem(16)};
`;
const Image = styled.img`
  width: ${rem(48)};
  height: auto;
  margin-right: ${rem(16)};
`;
const NameWrapper = styled(Flexbox)`
  height: 100%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  max-width: ${rem(320)};
  ${({ theme }) => theme.mediab.l1150`
    font-size: ${rem(14)};
    max-width: 100%;
    padding: ${rem(4)} 0;
`}
`;
const ProductName = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  text-decoration: none;
`;
const AttribInfo = styled(TextP)`
  font-size: ${rem(10)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.footer};
`;
const OnStockWrapper = styled(TextP)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  display: flex;
  justify-content: center;
  white-space: nowrap;
  padding-left: ${rem(8)};
  ${({ theme }) => theme.mediab.s450`
  margin: ${rem(8)};
`}
`;
const PriceWrapper = styled(FlexCol)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(24)};
  margin-left: ${rem(48)};
  max-width: ${rem(54)};
  width: ${rem(54)};
  text-align: end;
  white-space: nowrap;
  ${({ theme }) => theme.mediab.l1150`
    margin-left: ${rem(24)};
  `}
`;
const AmountWrapper = styled(FlexCol)``;

const CartButton = styled(ButtonPrimary)`
  width: ${rem(48)};
  padding: 0;
  margin-top: ${rem(16)};
  margin-bottom: ${rem(16)};

  &:disabled {
    background-color: #dcd6d6;
    color: ${({ theme }) => theme.colors.black};

    svg {
      fill: ${({ theme }) => theme.colors.black};

      * {
        fill: inherit;
      }
    }
  }

  ${({ theme }) => theme.mediab.s450`
    margin: ${rem(8)};
  `}
`;

const AddToCartWrapper = styled(FlexCol)``;
const RemoveWrapper = styled(FlexCol)``;

export { WishlistProductRow };
